const e=(e,r)=>{const t=e.findIndex(((e,t,n)=>r(e,t,n)));return{before:e.slice(0,t),separator:e[t],after:e.slice(t+1)}};export{e as splitByPredicate};
